import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

const animateScrolling = () => {
  function animateFrom(elem, direction) {
    direction = direction || 1;
    var x = 0,
      y = direction * 100;
    if (elem.classList.contains('an_fl')) {
      x = -100;
      y = 0;
    } else if (elem.classList.contains('an_fr')) {
      x = 100;
      y = 0;
    } else if (elem.classList.contains('an_fb')) {
      x = 0;
      y = 100;
    } else if (elem.classList.contains('an_ft')) {
      x = 0;
      y = -100;
      // eslint-disable-next-line sonarjs/no-duplicated-branches
    } else {
      x = 0;
      y = 100;
    }
    elem.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
    elem.style.opacity = '0';

    gsap.set(elem, { x: x, y: y, autoAlpha: 0 });
    gsap.to(elem, 2.4, {
      x: 0,
      y: 0,
      autoAlpha: 1,
      ease: 'expo',
      overwrite: 'auto',
    });
  }

  function hide(elem) {
    gsap.set(elem, { autoAlpha: 0 });
  }

  //gsap.registerPlugin(ScrollTrigger);

  gsap.utils
    .toArray([
      '.an',
      '.sc-timeline .wp-block-columns',
      '.bc-title',
      '.sc-page__ctab .wp-block-columns',
      '.sc-brand__text',
      '.sc-brand__info',
    ])
    .forEach(function (elem) {
      hide(elem); // assure that the element is hidden when scrolled into view

      ScrollTrigger.create({
        trigger: elem,
        start: '100 bottom',
        toggleActions: 'play none none none',
        once: true,

        onEnter: function () {
          animateFrom(elem);
        },
      });
    });

  //gsap.registerPlugin(ScrollTrigger);

  if (document.querySelector('.sc-blog__list') !== null) {

    const blogList = '.sc-blog__list .grid-post .wp-block-column';
    gsap.set(blogList, {autoAlpha: 0, y: 100});

    ScrollTrigger.create({
      trigger: blogList,
      start: '100 bottom',
      toggleActions: 'play none none none',
      once: true,

      onEnter: function () {
        gsap.to(blogList, 2.4, {
          x: 0,
          y: 0,
          autoAlpha: 1,
          ease: 'expo',
          overwrite: 'auto',
          stagger: 0.3,
        });
      },
    });
  }
};

export { animateScrolling };
